import React from "react"
import PropTypes from "prop-types"
import { Button, Flex, Modal } from "antd"
import { useTranslation } from "react-i18next"
import styles from "./WidgetLayout.module.css"

// "Are you sure you want to exit?" for the widget's X. A plain modal: the shared confirm modals
// (ui/ConfirmModal, ui/NewConfirmModal) carry a warning icon and danger buttons the design doesn't.
const ExitConfirmModal = ({ isOpen, onContinue, onExit }) => {
  const { t } = useTranslation()
  return (
    <Modal
      open={isOpen}
      onCancel={onContinue}
      footer={null}
      centered
      width={472}
      title={<span className={styles.exitTitle}>{t("booking_widget.exit.title")}</span>}
    >
      <Flex vertical gap={24}>
        <span className={styles.exitText}>{t("booking_widget.exit.text")}</span>
        <Flex gap={12} wrap="wrap">
          <Button shape="round" size="large" color="primary" variant="outlined" onClick={onContinue}>
            {t("booking_widget.exit.continue")}
          </Button>
          <Button shape="round" size="large" type="primary" className={styles.exitButton} onClick={onExit}>
            {t("booking_widget.exit.exit")}
          </Button>
        </Flex>
      </Flex>
    </Modal>
  )
}

ExitConfirmModal.propTypes = {
  isOpen: PropTypes.bool,
  onContinue: PropTypes.func.isRequired,
  onExit: PropTypes.func.isRequired
}

ExitConfirmModal.defaultProps = {
  isOpen: false
}

export default ExitConfirmModal
